import {
  faBriefcase,
  faBuilding,
  faHouse,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import "./AddNewAddress.css";
import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import { useLocation, useNavigate } from "react-router-dom";

import "react-phone-input-2/lib/style.css";
import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
import Gray_Btn from "../Common-Component/common_btn/gray_btn/Gray_Btn";
import {
  postAddress,
  getSingleAddress,
} from "../../utils/apis/orderProcess/orderProcess";
// import Your_Location_Info_Modal from "../Common_modal/your_location_info_modal/Your_Location_Info_Modal";
import { Context } from "../../utils/context";
import { RegxExpression } from "../../utils/common";
// import Your_Location_Info_Modal from "../common_components/common_modal/your_location_info_modal/Your_Location_Info_Modal";

const AddNewAddress = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { IMG_URL, currentLocation } = useContext(Context);
  const searchParams = new URLSearchParams(location.search);
  const editId = searchParams.get("id");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    setValue,
  } = useForm();

  const [activeBtn, setActiveBtn] = useState("Apartment");

  useEffect(() => {
    if (editId) {
      fetchSingleAddress();
    }
  }, [editId]);

  const fetchSingleAddress = async () => {
    const res = await getSingleAddress(editId);

    if (res?.success && res?.data) {
      const d = res.data;

      setActiveBtn(d.address_type || "Apartment");

      reset({
        email: d.email,
        name: d.name,
        flat_home_bldg: d.flat_home_bldg,
        society_name: d.society_name,
        area_name: d.area_name,
        apt_number: d.apt_number,
        floor: d.floor,
        company: d.company,
        col_land_street: d.col_land_strt,
        additional_direction: d.additional_direction,
        contact_no: d.mobile_number,
      });
    }
  };

  const onSubmit = async (data) => {
    const sendData = {
      id: editId || undefined,
      address_type: activeBtn,
      email: data?.email,
      name: data?.name,
      flat_home_bldg: data?.flat_home_bldg,
      society_name: data?.society_name,
      area_name: data?.area_name,
      apt_number: data?.apt_number,
      floor: data?.floor,
      company: data?.company,
      col_land_strt: data?.col_land_street,
      additional_direction: data?.additional_direction,
      mobile_number: data?.contact_no,
      latitude:
        currentLocation?.geometry?.location?.lat ||
        currentLocation?.coordinates?.lat,
      longitude:
        currentLocation?.geometry?.location?.lng ||
        currentLocation?.coordinates?.lng,
    };

    const res = await postAddress(sendData);

    if (res?.success) {
      navigate("/saved-address");
    }
  };

  useEffect(() => {
    if (currentLocation?.formatted_address) {
      setValue("col_land_street", currentLocation.formatted_address);
    }
  }, [currentLocation, setValue]);
  return (
    <section className="AddNewAddress">
      <div className="container">
        <div className="add_new_address_main_div">
          <div className="data_holder">
            <div className={"map-section"}>
              <div className="mapouter">
                <div className="gmap_canvas">
                  <iframe
                    className="gmap_iframe"
                    src={`https://maps.google.com/maps?q=${currentLocation?.geometry?.location?.lat},${currentLocation?.geometry?.location?.lng}&hl=en&z=14&output=embed`}
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
              <div className={"overlaycolor"}></div>

              <div className="area_main_div">
                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="location_icon"
                  />
                </div>

                <div className="area_div">
                  <p className="area_heading">Area</p>

                  <div className="footer_text">
                    <div className="">
                      <p className="city_name">
                        {currentLocation?.formatted_address}
                      </p>
                    </div>

                    <div
                      className="right_side_text"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <p className="green_text_underline">Change</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="address_form_main_div">
              <div className="address_type_btn_holder">
                <div
                  className={`address_type_btn ${
                    activeBtn === "Apartment" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn("Apartment");
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBuilding} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Apartment</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${
                    activeBtn === "House" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn("House");
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faHouse} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>House</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${
                    activeBtn === "Office" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn("Office");
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBriefcase} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Office</p>
                  </div>
                </div>
              </div>

              <Form className="form_div" onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <Form.Control
                      type="text"
                      name="Full Name"
                      placeholder="Full Name*"
                      {...register("name", {
                        required: "Full Name required",
                      })}
                    />
                    {errors?.name && (
                      <sup className="text-danger">{errors?.name?.message}</sup>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <Form.Control
                      type="text"
                      name="Email"
                      placeholder="Email*"
                      {...register("email", {
                        required: "Email required",
                        pattern: {
                          value: RegxExpression.email,
                          message: "Please enter a valid email address",
                        },
                      })}
                    />
                    {errors?.email && (
                      <sup className="text-danger">
                        {errors?.email?.message}
                      </sup>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <Form.Control
                      type="text"
                      name="Building name"
                      placeholder="Building name*"
                      {...register("flat_home_bldg", {
                        required: "Building name required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.flat_home_bldg,
                        "is-valid": getValues("flat_home_bldg"),
                      })}
                    />
                    {errors?.flat_home_bldg && (
                      <sup className="text-danger">
                        {errors?.flat_home_bldg?.message}
                      </sup>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {activeBtn === "House" || activeBtn === "Office" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="Area Name"
                          placeholder="Area Name"
                          {...register("area_name", {
                            required: "Area name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.area_name,
                            "is-valid": getValues("area_name"),
                          })}
                        />
                        {errors?.area_name && (
                          <sup className="text-danger">
                            {errors?.area_name?.message}
                          </sup>
                        )}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          type="text"
                          name="Society Name"
                          placeholder="Society name*"
                          {...register("society_name", {
                            required: "Society name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.society_name,
                            "is-valid": getValues("society_name"),
                          })}
                        />
                        {errors?.society_name && (
                          <sup className="text-danger">
                            {errors?.society_name?.message}
                          </sup>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    {activeBtn === "House" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="Floor"
                          placeholder="Floor*"
                          {...register("floor", {
                            required: "Floor is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.floor,
                            "is-valid": getValues("floor"),
                          })}
                        />
                        {errors?.floor && (
                          <sup className="text-danger">
                            {errors?.floor?.message}
                          </sup>
                        )}
                      </>
                    ) : activeBtn === "Apartment" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="area_name"
                          placeholder="Area Name"
                          {...register("area_name", {
                            required: "Area name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.area_name,
                            "is-valid": getValues("area_name"),
                          })}
                        />
                        {errors?.area_name && (
                          <sup className="text-danger">
                            {errors?.area_name?.message}
                          </sup>
                        )}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          type="text"
                          name="Company"
                          placeholder="Company*"
                          {...register("company", {
                            required: "Company is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.company,
                            "is-valid": getValues("company"),
                          })}
                        />{" "}
                        {errors?.company && (
                          <sup className="text-danger">
                            {errors?.company?.message}
                          </sup>
                        )}
                      </>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {activeBtn === "House" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="Street Name"
                          placeholder="Street*"
                          {...register("col_land_street", {
                            required: "Street name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.col_land_street,
                            "is-valid": getValues("col_land_street"),
                          })}
                        />{" "}
                        {errors?.col_land_street && (
                          <sup className="text-danger">
                            {errors?.col_land_street?.message}
                          </sup>
                        )}
                      </>
                    ) : activeBtn === "Apartment" ? (
                      <>
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <Form.Control
                              type="text"
                              name="Apartment Number"
                              placeholder="Apt. no.*"
                              {...register("apt_number", {
                                required: "Apartment Number is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.apt_number,
                                "is-valid": getValues("apt_number"),
                              })}
                            />
                            {errors?.apt_number && (
                              <sup className="text-danger">
                                {errors?.apt_number?.message}
                              </sup>
                            )}
                          </div>

                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <Form.Control
                              type="text"
                              name="Floor"
                              placeholder="Floor*"
                              {...register("floor", {
                                required: "Floor is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.floor,
                                "is-valid": getValues("floor"),
                              })}
                            />
                            {errors?.floor && (
                              <sup className="text-danger">
                                {errors?.floor?.message}
                              </sup>
                            )}
                          </div>
                        </div>
                      </>
                    ) : activeBtn === "Office" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="Floor"
                          placeholder="Floor*"
                          {...register("floor", {
                            required: "Floor is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.floor,
                            "is-valid": getValues("floor"),
                          })}
                        />
                        {errors?.floor && (
                          <sup className="text-danger">
                            {errors?.floor?.message}
                          </sup>
                        )}
                      </>
                    ) : null}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    {activeBtn === "House" ? (
                      <>
                        <Form.Control
                          type="text"
                          name="Additional directions"
                          placeholder="Additional directions (optional)"
                          {...register("additional_direction", {
                            // required: "First name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.additional_direction,
                            "is-valid": getValues("additional_direction"),
                          })}
                        />
                        {errors?.additional_direction && (
                          <sup className="text-danger">
                            {errors?.additional_direction?.message}
                          </sup>
                        )}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          type="text"
                          name="Street Name"
                          placeholder="Street*"
                          {...register("col_land_street", {
                            required: "Street name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.col_land_street,
                            "is-valid": getValues("col_land_street"),
                          })}
                        />
                        {errors?.col_land_street && (
                          <sup className="text-danger">
                            {errors?.col_land_street?.message}
                          </sup>
                        )}
                      </>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {activeBtn === "House" ? (
                      <>
                        <Controller
                          className="phone_input"
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Contact No is required",
                            minLength: {
                              value: 10,
                              message:
                                "Number should be at least 10 characters",
                            },
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country="in"
                              {...field}
                              className={classNames("", {
                                "is-invalid": errors?.contact_no,
                                "is-valid": getValues("contact_no"),
                              })}
                              onChange={(value) => field.onChange(value)}
                              type="text"
                              placeholder="Enter Mobile Number"
                              maxLength={10}
                            />
                          )}
                        />
                        {errors?.contact_no && (
                          <sup className="text-danger">
                            {errors?.contact_no?.message}
                          </sup>
                        )}

                        {/* <div className="row">
                          <div className="">
                            <p className="green_text_underline">Add Contact</p>
                          </div>
                        </div> */}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          type="text"
                          name="Additional direction"
                          placeholder="Additional directions (optional)"
                          {...register("additional_direction", {
                            // required: "Additional direction is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.additional_direction,
                            "is-valid": getValues("additional_direction"),
                          })}
                        />
                        {errors?.additional_direction && (
                          <sup className="text-danger">
                            {errors?.additional_direction?.message}
                          </sup>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {activeBtn === "House" ? (
                  <div className=""></div>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <Controller
                          className="phone_input"
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "contact_no is required",
                            minLength: {
                              value: 10,
                              message:
                                "Number should be at least 10 characters",
                            },
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country="in"
                              {...field}
                              className={classNames("", {
                                "is-invalid": errors?.contact_no,
                                "is-valid": getValues("contact_no"),
                              })}
                              onChange={(value) => field.onChange(value)}
                              type="text"
                              placeholder="Enter Mobile Number"
                              maxLength={10}
                            />
                          )}
                        />
                        {errors?.contact_no && (
                          <sup className="text-danger">
                            {errors?.contact_no?.message}
                          </sup>
                        )}
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <p className="green_text_underline">Add Contact</p>
                      </div>
                    </div> */}
                  </>
                )}

                <div className="text-center btn_holder mt-3">
                  <Green_Btn btn_name="Save Address" type="submit" />
                  <Gray_Btn
                    btn_name="Cancel"
                    onClick={() => navigate("/saved-address")}
                  />
                </div>
              </Form>

              {/* <div className="text-center btn_holder">
                <Green_Btn
                  btn_name="Save Address"
                  //   onClick={() => {
                  //     navigate("/saved-address");
                  //   }}
                  type="submit"
                />
                <Gray_Btn
                  btn_name="Cancel"
                  onClick={() => {
                    navigate("/saved-address");
                  }}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <Your_Location_Info_Modal
        btnText="Enter Complete Address"
        show={showModal}
        onHide={() => setShowModal(false)}
        orange_btn_text={"Enter Address"}
        green_btn_text={"Verify Address"}
        showText={false}
        modalTitle="Your Location Info"
      /> */}
    </section>
  );
};

export default AddNewAddress;
